import { render, staticRenderFns } from "./myselfRole.vue?vue&type=template&id=566c7592&scoped=true"
import script from "./myselfRole.vue?vue&type=script&lang=js"
export * from "./myselfRole.vue?vue&type=script&lang=js"
import style0 from "./myselfRole.vue?vue&type=style&index=0&id=566c7592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c7592",
  null
  
)

export default component.exports